import React from 'react';
import Api from "../../model/Api";
import Axios from "axios";
import '../../../assets/whypc/css/preview.css';
// @ts-ignore
import { Link } from 'react-router-dom';
//import cover from "https://video.hnbxwhy.com/activity/3b8e0b39-bbe7-48ff-8c3c-4065a3a0596f.png";

class Preview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cid: this.getQueryString(this.props.location.search,'cid'),
            activeTab: 'content',
            courseInfo: null,
            courseTypeName: [],
            imagePreviewUrl: null,
        }
    }
    componentDidMount(){
        this.getCourseInfo(this.state.cid);
    }
    getCourseInfo(cid){
         Axios.get(Api.gitCouresInfo+"?id="+cid).then((res) => {
            console.log(res.data.data);
            const data = res.data.data;
            this.setState({courseInfo: data});
            if (data.courseTypeName) {
                this.setState({courseTypeName: data.courseTypeName.split(',')});
            }
         })
    }
 getQueryString= (url,name) =>{
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        console.log(reg)
        var r = url.substr(1).match(reg);
        console.log(r)
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    }
    getUrl(id){
        
        Axios.get(Api.getUrl+"?courseAttachmentId="+id).then((res) => {
            console.log(res.data.data);
            console.log(window.location.href)
            let params={
					source:3,
					userId:0,
					accessUrl:window.location.href,
					gCategory:6,
					relId:id,
				}
            this.sendadd(params)
           // return;
           console.log('打开文件')
            window.open(res.data.data);
        })
    }
    videosend(){
        let params={
					source:3,
					userId:0,
					accessUrl:window.location.href,
					gCategory:5,
					relId:this.state.cid,
				}
        this.sendadd(params)
    }
   sendadd(params){

        Axios.post(Api.sendAdd,params).then((res) => {
            console.log(res.data.data);
        })
    }
    isImage(name){
        if(!name) return false;
        const ext = name;
        return ['jpg','jpeg','png','gif','bmp','webp','svg'].includes(ext);
    }
    viewImage(id,url){
        // Axios.get(Api.getUrl+"?courseAttachmentId="+id).then((res) => {
        //     let params={
        //         source:3,
        //         userId:0,
        //         accessUrl:window.location.href,
        //         gCategory:6,
        //         relId:id,
        //     }
        //     this.sendadd(params)
            
        //})
        let params={
                source:3,
                userId:0,
                accessUrl:window.location.href,
                gCategory:6,
                relId:id,
            }
            this.sendadd(params)
        this.setState({ imagePreviewUrl: url });
    }
    closeImagePreview = () => {
        this.setState({ imagePreviewUrl: null });
    }
    render() {
        const { activeTab, courseInfo, courseTypeName } = this.state;
        
        if (!courseInfo || Object.keys(courseInfo).length === 0) {
            return (
                <div className="preview-container">
                    <div className="loading">加载中...</div>
                </div>
            );
        }
        let video
        if(courseInfo.hasVideo === 1||courseInfo.videoPreviewUrl !== ''){
            video=( <Link to={"/VideoPlayer?id="+this.state.cid} className="resource-item" target="_blank" onClick={(e) => {
                e.preventDefault();
                this.videosend();
                window.open("/#/VideoPlayer?id="+this.state.cid, "_blank");
            }}>
                                            <span className="resource-icon">🎬</span>
                                            <span className="resource-name">【视频】{courseInfo.name}</span>
                                        </Link>)
        }else{
            video=null;
        }
        return (
            <div className="preview-container">
                <div className="preview-header">
                    <Link to="/video" className="back-btn">
                        <span className="arrow">←</span> 返回
                    </Link>
                </div>

                <div className="preview-content">
                    <div className="course-info">
                        <div className="cover-wrapper">
                            <img src={courseInfo.coverUrl} alt="课程封面" className="cover-img" />
                        </div>
                        <div className="course-detail">
                            <h1 className="course-title">{courseInfo.name}</h1>
                            <div className="tags">
                                {courseTypeName && courseTypeName.map((item, index) => (
                                    <span key={index} className="tag">{item}</span>
                                ))}
                                <span className="tag">{courseInfo.gradeFromName}~{courseInfo.gradeToName}</span>
                            </div>
                        </div>
                    </div>

                    <div className="tab-container">
                        <div className="tabs">
                            <button
                                className={`tab ${activeTab === 'content' ? 'active' : ''}`}
                                onClick={() => this.setState({ activeTab: 'content' })}
                            >
                                教学内容
                            </button>
                            <button
                                className={`tab ${activeTab === 'intro' ? 'active' : ''}`}
                                onClick={() => this.setState({ activeTab: 'intro' })}
                            >
                                课程介绍
                            </button>
                        </div>

                        <div className="tab-content">
                            {activeTab === 'content' ? (
                                <div className="content-panel">
                                    <div className="resource-list">
                                        {courseInfo.attachments && courseInfo.attachments.map((item, index) => {
                                            const isImg = this.isImage(item.extension);
                                            return (
                                                <div key={index} className="resource-item" onClick={() => isImg ? this.viewImage(item.id,item.fileUrl) : this.getUrl(item.id)}>
                                                    <span className="resource-icon">{isImg ? '🖼️' : '📄'}</span>
                                                    <span className="resource-name">{item.name}</span>
                                                </div>
                                            );
                                        })}
                                       {video}
                                    </div>
                                </div>
                            ) : (
                                <div className="intro-panel">
                                    <p className="intro-text">
                                        {courseInfo.description || '暂无课程介绍'}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {this.state.imagePreviewUrl && (
                    <div className="image-preview-modal" onClick={this.closeImagePreview}>
                        <span className="image-preview-close">×</span>
                        {/* <div className="image-preview-tip">图片仅供查看，禁止下载</div> */}
                        <img
                            src={this.state.imagePreviewUrl}
                            alt="图片预览"
                            className="image-preview-content"
                            draggable={false}
                            onContextMenu={(e) => e.preventDefault()}
                            onDragStart={(e) => e.preventDefault()}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                )}
            </div>
        )
    }
}

export default Preview;